import dayjs from 'dayjs'
import 'normalize.css'
import Vue from 'vue'
import App from './App.vue'
import './directives'
import router from './router/index'
import { store } from './store'
import './styles/index.scss'
// 国际化
import globalMixin from '@/mixins/globalMixin'
import { Loading, Message, MessageBox, Notification } from '@/setup/elementUI'
import { i18n } from '@/setup/i18n-setup'
// import { loadGoogleMapJs } from '@/utils/googleMap'
import BasicBpcComponent from '@mybeauty/basic-bpc-component'
import '@mybeauty/basic-bpc-component/BasicBpcComponent.css'
import 'element-ui/lib/theme-chalk/index.css'
import PubSub from 'pubsub-js'
import { getDomainTheme } from './utils/localStorage'
import { switchTheme } from './views/home/setup'

if (process.env.isVite) {
  await import('@mybeauty/basic-bpc-component/BasicBpcComponent.css')
  const ElementUI = await import('element-ui')
  Vue.use(ElementUI)
}

// loadGoogleMapJs()
Vue.config.productionTip = false
Vue.prototype.$dayjs = dayjs
Vue.prototype.$pubsub = PubSub

Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message

Vue.prototype.$ELEMENT = {
  i18n: (key, value) => i18n.t(key, value),
  size: 'small',
  zIndex: 2000
}

Vue.use(BasicBpcComponent, {
  mbI18n: (key, value) => i18n.t(key, value),
  getI18n: () => i18n
})

Vue.mixin(globalMixin)

const domainTheme = getDomainTheme()

switchTheme(domainTheme?.theme).finally(() => {
  new Vue({
    i18n,
    router,
    store,
    render: (h) => h(App)
  }).$mount('#app')
})

// https://texteditor.com/font-converter/
// console.info(
//   `
// %c
// 𝑾𝒆𝒍𝒄𝒐𝒎𝒆 𝒕𝒐 𝑴𝒚 𝑩𝒆𝒂𝒖𝒕𝒚
// `,
//   'color: #ff889f; font-size: 32px;'
// )
